import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IAugmentedJQuery, IController, IFormController, INgModelController, IPromise} from "angular";
import {Debugger} from "debug";
import {l} from "../../../../../types/typescriptdefinisjoner_lederplan";
import {Kontekst} from "../../../../../felles/tjenester/Kontekst";
import _ from "lodash";

const debug: Debugger = require('debug')('ReautentiseringDialogKontroller');
const css = require('./reautentisering.scss');

export class ReautentiseringDialogKontroller implements IController {

    static visReautentiseringDialog(melding: string,
                                    vedAutentiseringsinfoAngitt: (autentiseringsinfo: l.Reautentiseringsinformasjon) => IPromise<boolean>,
                                    $mdDialog: angular.material.IDialogService): IPromise<void> {
        return $mdDialog.show({
            template: require('./reautentisering.html'),
            controller: ReautentiseringDialogKontroller.forInjisering(),
            controllerAs: '$ctrl',
            bindToController: true,
            multiple: true, //tillater at vi viser denne dialogen uten at eventuelle eksisterende dialoger lukkes
            locals: {
                melding: melding,
                vedAutentiseringsinfoAngitt: vedAutentiseringsinfoAngitt
            }
        });
    }

    static forInjisering() {
        return [
            regNavn.ng.$element,
            regNavn.md.$mdDialog,
            Kontekst.regNavn,
            ReautentiseringDialogKontroller
        ]
    }

    constructor(private $element: IAugmentedJQuery,
                private $mdDialog: angular.material.IDialogService,
                private kontekst: Kontekst) {
    }

    melding: string; //settes via locals i dialogKonfigurasjon
    vedAutentiseringsinfoAngitt: (autentiseringsinfo: l.Reautentiseringsinformasjon) => IPromise<boolean>; //settes via locals i dialogKonfigurasjon

    modus: 'passord' | 'eid' = 'passord';
    brukerHarEidAktivert = false;
    eidModus = l.CriiptoGuiModus.popup; //dersom vi velger noe annet enn popup må criipto callback håndteres på annet vis
    eidMetoder: l.CriiptoIdTilbyder[];
    eidMatcherIkkeInnloggetBruker = false;
    passord: string;

    private benyttetMetode: l.BenyttetAutentiseringsmetode;
    private criiptoTilbyder: l.CriiptoIdTilbyder;

    vedEidValgt(tilbyder: l.CriiptoIdTilbyder) {
        this.criiptoTilbyder = tilbyder;
        switch (tilbyder) {
            case l.CriiptoIdTilbyder.norsk_bankid_web_og_mobil:
                this.benyttetMetode = l.BenyttetAutentiseringsmetode.bankidNorsk;
                break;
            case l.CriiptoIdTilbyder.svensk_bankid_samedevice:
            case l.CriiptoIdTilbyder.svensk_bankid_anotherdevice:
            case l.CriiptoIdTilbyder.svensk_bankid_anotherdeviceqr:
                this.benyttetMetode = l.BenyttetAutentiseringsmetode.bankidSvensk;
                break;
        }
    }

    vedEidAutentisert(token: string) {
        return this.vedAutentiseringsinfoAngitt({metode: this.benyttetMetode, eid: {autentiseringskode: token, tilbyder: this.criiptoTilbyder, guiModus: l.CriiptoGuiModus.popup}})
            .then(autentiseringOk => {
                if (!autentiseringOk) {
                    this.eidMatcherIkkeInnloggetBruker = true;
                    return;
                }
                this.lukkOgReturner();
            });
    }

    vedCriiptoAvbrutt() {
        this.avbryt();
    }

    passordAngitt(skjema: IFormController) {
        this.vedAutentiseringsinfoAngitt({metode: this.benyttetMetode, passord: this.passord})
            .then(passordOk => {
                skjema.passordFelt.$setValidity('ugyldigPassord', passordOk);
                if (!passordOk) return;
                this.lukkOgReturner();
            });
    }

    passordEndret(passordFelt: INgModelController) {
        if (passordFelt.$invalid) passordFelt.$setValidity('ugyldigPassord', true);
    }

    avbryt() {
        this.$mdDialog.cancel();
    }

    $onInit(): void {
        switch (this.kontekst.aktivtTokenInfo().autentiseringsmetode) {
            case l.BenyttetAutentiseringsmetode.bankidNorsk:
                this.reautentiserMedEid([l.CriiptoIdTilbyder.norsk_bankid_web_og_mobil]);
                break;
            case l.BenyttetAutentiseringsmetode.bankidSvensk:
                this.reautentiserMedEid([l.CriiptoIdTilbyder.svensk_bankid_samedevice, l.CriiptoIdTilbyder.svensk_bankid_anotherdevice, l.CriiptoIdTilbyder.svensk_bankid_anotherdeviceqr]);
                break;
            default:
                this.reautentiserMedPassord();
        }
        this.brukerHarEidAktivert = _.includes(this.kontekst.autentisertBruker().autentiseringsmetoder, l.Autentiseringsmetode.criiptoOpenId);
    }

    //hjelpemetoder

    private lukkOgReturner() {
        this.$mdDialog.hide();
    }

    private reautentiserMedPassord() {
        this.modus = 'passord';
        this.benyttetMetode = l.BenyttetAutentiseringsmetode.passord;

        //for å unngå at nettleser fyller ut passord automatisk - som medfører at brukernavn blir fylt inn i søkefeltet
        //(eller annet inputfelt som måtte være synlig i tillegg til passordfeltet) rendres passordfeltet først med type=text
        //for så etter 1 sekund å bli endret til type=password
        setTimeout(()=>{
            this.$element.find('#wd-reautentiseringDialog-passordfelt').attr('type', 'password');
        }, 1000);
    }

    private reautentiserMedEid(tilgjengeligMetoder: l.CriiptoIdTilbyder[]) {
        this.modus = 'eid';
        this.eidMetoder = tilgjengeligMetoder;
    }
}
